<template>
    <nav
        v-if="totalPages"
        class="p-pagination">
        <h4
            class="p-pagination__title"
            title="Страницы">
            Страницы
        </h4>
        <ul class="p-pagination__list">
            <template v-if="isShowLeftMiddle">
                <li class="p-pagination__item">
                    <a
                        :href="1"
                        title="Страница 1"
                        @click.prevent="updateData(1)">1</a>
                </li>
                <li class="p-pagination__item">
                    <a
                        :href="leftMiddleValue"
                        :title="'Страница ' + leftMiddleValue"
                        @click.prevent="updateData(leftMiddleValue)">
                        <span class="p-pagination__points"></span>
                    </a>
                </li>
            </template>
            <li
                v-for="page in showedList"
                :key="page"
                class="p-pagination__item"
                :class="{'active': page == currentPage }">
                <span v-if="page === currentPage">
                    {{page}}
                </span>
                <a
                    v-else
                    :href="page"
                    :title="'Страница ' + page"
                    @click.prevent="updateData(page)">{{page}}</a>
            </li>
            <template v-if="isShowRightMiddle">
                <li class="p-pagination__item">
                    <a
                        :href="rightMiddleValue"
                        :title="'Страница ' + rightMiddleValue"
                        @click.prevent="updateData(rightMiddleValue)">
                        <span class="p-pagination__points"></span>
                    </a>
                </li>
                <li class="p-pagination__item">
                    <a
                        :href="totalPages"
                        :title="'Страница ' + totalPages"
                        @click.prevent="updateData(totalPages)">{{totalPages}}</a>
                </li>
            </template>
        </ul>
        <a
            v-if="currentPage !== 1"
            class="p-pagination__btn p-pagination__btn--prev"
            :href="prevPage"
            title="Предыдущая страница"
            @click.prevent="updateData(prevPage)">Предыдущая</a>
        <a
            v-if="currentPage !== totalPages"
            class="p-pagination__btn p-pagination__btn--next"
            :href="nextPage"
            title="Следующая страница"
            @click.prevent="updateData(nextPage)">Следующая</a>
    </nav>
</template>

<script>
import scrollIt from '../../../modules/scroll-it';
export default {
    name: 'Pagination',
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        isSmallList() {
            return this.totalPages < 8;
        },
        prevPage() {
            return this.currentPage - 1;
        },
        nextPage() {
            return this.currentPage + 1;
        },
        isShowPrev() {
            return this.currentPage > 1;
        },
        isShowNext() {
            return this.currentPage < this.totalPages;
        },
        isShowLeftMiddle() {
            return (this.currentPage > 4) && !this.isSmallList;
        },
        isShowRightMiddle() {
            return ((this.totalPages - this.currentPage) > 3) && !this.isSmallList;
        },
        leftMiddleValue() {
            return Math.round((this.currentPage - 1) / 2);
        },
        rightMiddleValue() {
            return Math.round(this.totalPages - ((this.totalPages - (this.currentPage + 2)) / 2));
        },
        showedList() {
            let list = [];
            if (this.isSmallList) {
                let page = 1;
                while ((page - 1) < this.totalPages) {
                    list.push(page);
                    page++;
                }
            } else if ((this.totalPages - this.currentPage) < 4) {
                list.push(this.totalPages - 4);
                list.push(this.totalPages - 3);
                list.push(this.totalPages - 2);
                list.push(this.totalPages - 1);
                list.push(this.totalPages);
            } else if (this.currentPage > 4) {
                list.push(this.currentPage - 2);
                list.push(this.currentPage - 1);
                list.push(this.currentPage);
                list.push(this.currentPage + 1);
                list.push(this.currentPage + 2);
            } else {
                list = [1, 2, 3, 4, 5];
            }
            return list;
        },
        getUrlLocation() {
            return window.location.pathname
        }
    },
    methods: {
        updateData(pageNumber) {
            this.scrollToStartAuctions();
            this.$emit('updateData', pageNumber);
        },
        scrollToStartAuctions() {
            const el = document.getElementById('auction-block');
            if (el) scrollIt(el, 500);
        },
    }
};
</script>